<template>
    <div class="mb-8">
        <v-radio-group :mandatory="false" v-model="selected" hide-details class="pa-0 mt-0">
            <template v-for="(item, key) in items">
                <v-radio :label="item.answer" :class="{'font-weight-black': item.font === '1'}" :value="key"  :key="key" color="green" ></v-radio>
                <img :src="`${API_URL}/storage/answers/${item.image}`" v-if="item.image" width="150">
            </template>
        </v-radio-group>
    </div>
</template>

<script>
    export default {
        props: ['items'],
        data(){
            return {
                selected: []
            }
        },

        watch: {
            selected: function (newVal) {
                this.$emit('change', newVal);
            }
        }
    }
</script>